import Vue from 'vue'
import store from '@/store/store'
import {VIEWS} from '@/views/names'
import VueRouter from 'vue-router'

import Init from '@/views/init/Init'
import Load from '@/views/load/Load'
import Error from '@/views/error/Error'
import Receipt from '@/views/receipt/Receipt'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    name: VIEWS.init.name,
    component: Init
  },
  {
    path: '/load',
    name: VIEWS.load.name,
    component: Load
  },
  {
    path: '/error',
    name: VIEWS.error.name,
    component: Error,
    props: true
  },
  {
    path: '/receipt',
    name: VIEWS.receipt.name,
    component: Receipt
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if ((to.name !== VIEWS.init.name)) {
    if (!store.state.gui.tryInit) {
      next({
        name: VIEWS.init.name
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
